import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import ElectronicDPNChangeForm from './ElectronicDPNChangeForm';
import useTranslation from '../../../../../Hooks/useTranslation';
import { NCZIEntry, NCZIExtension } from '../../../Interfaces/ncziTypes';
import { Size } from '../../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	electronicConfirmation: NCZIEntry;
	preloadedData?: any;
}

const ElectronicDPNChangeModal: React.FC<Props> = props => {
	const {
		opened,
		onClose,
		patientIdentifier,
		electronicConfirmation,
		preloadedData,
	} = props;

	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			size={Size.SM}
			wrapChat={isCase}>
			<Modal.Header title='nczi.electronicDPN.change.title' firstUpper />
			<Modal.Content>
				<ElectronicDPNChangeForm
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					electronicConfirmation={electronicConfirmation}
					preloadedData={preloadedData}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicDPNChangeModal;
